/**
 * Created by razial on 05.12.2022
 */

const Aims = function () {
    this.targets = {};
    this.timeouts = {};
    this.runningDeltaActions = {};
};

Aims.prototype.clear = function () {
    for (const type in this.targets) {
        this.targets[type].forEach(this.clearHideTimeout.bind(this));
        this.targets[type] = [];
    }

    this.onceAllHiddenCallback = undefined;
};

Aims.prototype.registerTarget = function (types, target, options) {
    options = { ...options };
    types = cleverapps.toArray(types);

    if (!types || !types.length) {
        cleverapps.throwAsync("no type specified for aim");
        return;
    }

    if (!target) {
        cleverapps.throwAsync("no target specified for aim");
        return;
    }

    if (target.aim) {
        cleverapps.throwAsync("target already registered as an aim");
        return;
    }

    options.types = types;
    options.priority = options.priority || 0;
    target.aim = options;

    types.forEach((type) => {
        if (!this.targets[type]) {
            this.targets[type] = [];
        }

        const targets = this.targets[type];
        targets.push(target);

        for (let i = targets.length - 1; i > 0 && target.aim.priority < targets[i - 1].aim.priority; --i) {
            const tmp = targets[i - 1];
            targets[i - 1] = targets[i];
            targets[i] = tmp;
        }
    });

    target.addCleaner(this.removeTarget.bind(this, target));
};

Aims.prototype.removeTarget = function (target) {
    if (!target.aim) {
        return;
    }

    target.aim.types.forEach((type) => {
        const index = this.targets[type].indexOf(target);
        if (index !== -1) {
            this.targets[type].splice(index, 1);
        }
    });

    this.clearHideTimeout(target);
    target.aim = undefined;
};

Aims.prototype.clearHideTimeout = function (target) {
    const timeout = this.timeouts[target.__instanceId];
    if (timeout) {
        cleverapps.timeouts.clearTimeout(timeout);
        delete this.timeouts[target.__instanceId];
    }
};

Aims.prototype.getTarget = function (types, options) {
    if (types instanceof cc.Node) {
        return types;
    }

    options = options || {};

    types = cleverapps.toArray(types) || [];

    if (!options.noDefault) {
        types.push("default");
    }

    for (let j = 0; j < types.length; ++j) {
        const type = types[j];
        const targets = this.targets[type];
        if (targets) {
            const target = this.chooseTarget(targets);
            if (target) {
                return target;
            }
        }
    }
};

Aims.prototype.chooseTarget = function (targets) {
    for (let i = targets.length - 1; i >= 0; --i) {
        const target = targets[i];
        const aim = target.aim;

        if (!aim) {
            continue;
        }

        if (aim.filter && !aim.filter()) {
            continue;
        }

        if (!cleverapps.UI.isNodeOnScene(target, 0.3, 0.3)) {
            if (!aim.treasureBag && !aim.toggle && !aim.controls
                && !(aim.scrollsToTarget && aim.scrollsToTarget()) && !aim.canBeOffscreen) {
                continue;
            }
        }

        return target;
    }
};

Aims.prototype.showTarget = function (target) {
    if (!target || !target.aim) {
        return;
    }

    let wasVisible = true;

    if (target.aim.useGlobalZOrder) {
        target._setGlobalZOrder(true);
    }

    if (target.aim.toggle) {
        wasVisible = false;
        target.aim.toggle(true, false);
    } else if (target.aim.controls) {
        wasVisible = false;
        cleverapps.focusManager.showControlsTemporary(target.aim.controls);
    }

    if (this.timeouts[target.__instanceId]) {
        wasVisible = false;
        this.clearHideTimeout(target);
    }

    if (!wasVisible) {
        this.timeouts[target.__instanceId] = cleverapps.timeouts.setTimeout(this.hideTarget.bind(this, target), target.aim.duration || Aims.SHOW_DURATION);
    }
};

Aims.prototype.hideTarget = function (target) {
    this.clearHideTimeout(target);
    this.onceAllHidden();

    if (!target.aim) {
        return;
    }

    if (target.aim.useGlobalZOrder) {
        target._setGlobalZOrder(false);
    }

    if (target.aim.toggle) {
        target.aim.toggle(false, false);
    } else if (target.aim.controls) {
        cleverapps.focusManager.hideControlsTemporary(target.aim.controls);
    }
};

Aims.prototype.animateTarget = function (target, options) {
    if (target && target.aim && target.aim.animate) {
        target.aim.animate(options);
    }
};

Aims.prototype.hasShownTargets = function () {
    return !!Object.keys(this.timeouts).length;
};

Aims.prototype.whenAllHidden = function (callback) {
    this.onceAllHiddenCallback = callback;
    this.onceAllHidden();
};

Aims.prototype.onceAllHidden = function () {
    if (this.onceAllHiddenCallback && !this.hasShownTargets()) {
        cleverapps.timeouts.setTimeout(this.onceAllHiddenCallback, Aims.HIDE_ANIMATION_DURATION);
        this.onceAllHiddenCallback = undefined;
    }
};

Aims.prototype.showDelta = function (amount, target, options) {
    if (!target) {
        return;
    }

    const actionKey = (options.type || "") + target.__instanceId;

    const prevAction = this.runningDeltaActions[actionKey];
    if (prevAction) {
        prevAction.content.stopAction(prevAction.action);
        if (cleverapps.isNumber(amount) && !options.disableSummation) {
            amount = parseInt(amount) + parseInt(prevAction.amount);
        }
    }

    if (typeof amount !== "string") {
        amount = amount > 0 ? `+${amount}` : `${amount}`;
    }

    let icons;
    if (options.icon) {
        amount += "**";
        icons = {
            "**": options.icon
        };
    }

    const content = new TextWithIcon(amount, {
        font: options.font || cleverapps.styles.FONTS.WHITE_TEXT || cleverapps.styles.FONTS.TEXT,
        icons
    });
    content.setCascadeOpacityEnabledRecursively(true);

    if (options.bg) {
        const bg = new cc.Sprite(options.bg);
        bg.setPosition(content.width / 2, content.height / 2);
        bg.setLocalZOrder(-1);
        content.addChild(bg);
    }

    if (cleverapps.resolution.isVertical()) {
        content.setScale(0.7);
    }

    target.addChild(content);

    if (options.x !== undefined && options.y !== undefined) {
        content.setAlignment(options);
    } else {
        content.setAlignment(target.width * 0.5, target.height);
    }

    content.opacity = 0;
    content.visible = false;

    const action = new cc.AnimateDelta(0.7, 0.2, 0.2, content.height * (options.moveRate || 0.3)).setFinalize(() => {
        delete this.runningDeltaActions[actionKey];
        content.removeFromParent();
    });

    content.runAction(action);

    this.runningDeltaActions[actionKey] = {
        amount,
        action,
        content
    };
};

Aims.SHOW_DURATION = 1600;
Aims.HIDE_ANIMATION_DURATION = 200;
